import React from 'react';
import { Box, Flex } from 'grid-styled';

export default ({children}) => (
  <Box
    p={0}
    width={[1]}
  >
    <Flex
      column
      align='center'
    >
      {children}
    </Flex>
  </Box>
);



// WEBPACK FOOTER //
// ./src/components/Container.js